import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full transition-all duration-300 shadow-sm hover:shadow-md active:scale-[0.98]';
  const variants = {
    primary: 'bg-brand-coral text-white hover:bg-brand-coralHover',
    secondary: 'bg-brand-forest text-white hover:bg-opacity-90'
  };
  return <a className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-121">
      {children}
    </a>;
}